export const EDIT_EMERGENCY_CONTACT_DETAILS = {
  CONTACT_NAME: "ContactName",
  CONTACT_RELATION: "ContactRelation",
  CONTACT_EMAIL: "ContactEmail",
  CONTACT_NUMBER: "ContactNumber",
};

export const TYPE_OF_RELATION = [
  { label: "Father", value: "Father" },
  { label: "Mother", value: "Mother" },
  { label: "Self", value: "Self" },
];
